import { useState, useEffect } from "react";
import React from "react";
import {
  machineProfile,
  part,
  vendor,
  customer,
  partCategory,
  inventory as invetoryAPI,
  service,
  serviceCategory,
} from "../../api";
import { toast } from "react-toastify";
import {
  dateFormat,
  getEmptyField,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";
import { MachineElement } from "../../components/MachineElement";
import ImageViewer from "../../components/ImageViewer";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { Badge, ListGroup, Table } from "react-bootstrap";
import { format } from "date-fns";
import MultipleFilesAttachments from "../../components/MultipleFilesAttachments";
import { PermissionChecker } from "../../components/PermissionChecker";

function setupLocationValues(locationSeq, location) {
  locationSeq.push(location.id);
  if (location.parent_location) {
    setupLocationValues(locationSeq, location.parent_location);
  }
}
function AddService({ afterSubmitCallback }) {
  const { id } = useParams();
  const editMode = !!id;
  const { locations } = useDashboardContext();
  const [sublocations, setSublocations] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [vendorList, setVendor] = useState([]);
  const [customerList, setCustomer] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [inventories, setInventories] = useState([]);

  const [preview, setPreview] = useState();
  const [attachments, setAttachments] = useState([]);
  const [locationValue, setLocationValue] = useState([]);
  const { getLocationName, config } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [inventoryEditingIndex, setInventoryEditingIndex] = useState(null);

  const [dataToSend, setDataToSend] = useState({
    part_name: "",
    part_number: "",
    part_cost: "",
    vendor_id: "",
    customer_id: "",
    description: "",
    category_id: "",
  });
  const [inventory, setInventory] = useState({
    location_id: "",
    location_name: "",
    part_id: "",
    quantity: "",
    barcode: "",
    min_qty: "",
    max_qty: "",
  });
  const [open, setOpen] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const navigate = useNavigate();

  const [emptyField, setEmptyField] = useState([]);
  const [emptyFieldInventory, setEmptyFieldInventory] = useState([]);
  const [openDetailInventory, setOpenDetailInventory] = useState(false);
  const [detailInventory, setDetailInventory] = useState(null);

  function backToList() {
    navigate(-1);
  }

  const hideModal = () => {
    setOpenModal(false);
  };

  const createInventory = async () => {
    setOpenModal(true);
    emptyInventory();
    setInventoryEditingIndex(null);
  };

  const prosesInventory = async () => {
    let inv = inventories;
    let tmp = inventory;
    tmp.location_id = locationValue[sublocations.length - 1];

    console.log(inventory);
    const mandatory = ["quantity", "min_qty", "max_qty", "barcode"];
    const ef = getEmptyField(inventory, mandatory);
    if (!tmp.location_id) {
      ef.push("location_id");
    }
    setEmptyFieldInventory(ef);
    if (ef.length > 0) {
      toast.error("Mandatory field must be filled");
      return;
    }

    if (inventoryEditingIndex == null) {
      inv.push(tmp);
    } else {
      inv[inventoryEditingIndex] = tmp;
    }

    setInventories(inv);
    hideModal();
  };

  async function getMasterData() {
    try {
      setIsLoading(true);

      const getVendor = vendor.list({});

      const getCustomer = customer.list({});

      const getCategory = serviceCategory.list({});

      const [res, resCust, resCategory] = await Promise.all([
        getVendor,
        getCustomer,
        getCategory,
      ]);

      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.vendor_name;
            d["value"] = d.id;
          });
          setVendor(data);
        }
      }
      if (resCust.ok) {
        const body = await resCust.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.customer_name;
            d["value"] = d.id;
          });
          setCustomer(data);
        }
      }
      if (resCategory.ok) {
        const body = await resCategory.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.name;
            d["value"] = d.id;
          });
          setCategories(data);
        }
      }

      if (editMode) {
        await getRecord();
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    if (locations.length) setSublocations([locations]);
  }, [locations]);

  useEffect(() => {
    getMasterData();
  }, []);

  const deleteInventory = (index) => {
    console.log({ index });
    // delete inventories based on index of data
    let inv = inventories;
    inv.splice(index, 1);
    setInventories([...inv]);
  };

  const editInventory = (index) => {
    const inv = { ...inventories[index] };

    const invLocation = getLocationNameFromID(inv.location_id, false);
    //find parent
    const locationSeq = [];
    setupLocationValues(locationSeq, invLocation);
    locationSeq.reverse();

    setLocationValue(locationSeq);

    setInventory(inv);
    setOpenModal(true);
    setInventoryEditingIndex(index);
  };
  async function getRecord() {
    const result = await service.getOne(id);

    if (result.ok) {
      const body = await result.json();
      let data = body.data;

      const defaultValue = {
        service_name: data.service_name,
        vendor_id: data.vendor_id || "",
        customer_id: data.customer_id || "",
        description: data.description,
        category_id: data.category_id || "",
        service_cost: data.service_cost || 0,
      };
      if (data.service_image) {
        setPreview(renderImage(`/machine/attachment/` + data.service_image));
      }
      const att = [];
      if (data.attachments)
        Object.keys(data.attachments).forEach((key) => {
          if (data.attachments[key]) {
            const name = key.split("_")[3];
            const type = key.split("_")[2];
            const isRequest = key.split("_")[0] !== "workoder";
            const url = renderImage(
              `machine/attachment/${data.attachments[key]}`
            );
            const attachment = {
              origin_key: key,
              exist: true,
              name: name,
              type,
              url,
              value: data.attachments[key],
            };
            att.push(attachment);
          }
        });
      setAttachments(att);
      setInventories(data.inventory);
      setDataToSend(defaultValue);
    }
  }

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };

  const handleOnChangeInventory = (e) => {
    let key = e.target.name;

    setInventory((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };

  const emptyInventory = () => {
    setInventory({
      location_id: "",
      part_id: "",
      quantity: "",
      barcode: "",
      min_qty: "",
      max_qty: "",
    });
  };

  const handleMachineElementChange = (elements) => {
    setDataToSend((prevData) => ({
      ...prevData,
      deployments: JSON.stringify(elements),
    }));
  };

  const getLocationNameFromID = (val, onlyName = true) => {
    //inside locations there are sublocations array
    // check if the id is same as location or sublocations
    const loc = locations.find((l) => {
      return l.sublocations.find((s) => s.id === val);
    });
    if (loc) {
      if (loc.id === val) {
        return onlyName ? loc.location_name : loc;
      } else {
        return onlyName
          ? loc.sublocations.find((s) => s.id === val).location_name
          : loc.sublocations.find((s) => s.id === val);
      }
    }
  };

  useEffect(() => {
    let sublocations = locations;
    const copy = [sublocations];
    console.log({ locations });
    const findSublocation = (lv, index) => {
      const location = sublocations.find((l) => l.id == lv);

      if (
        location &&
        location.sublocations &&
        location.sublocations.length > 0
      ) {
        copy.splice(index + 1);
        copy.push(location.sublocations);
        sublocations = location.sublocations;
      } else {
        copy.splice(index + 1);
      }
    };

    if (locationValue.length > 0) {
      locationValue.forEach((lv, index) => {
        findSublocation(lv, index);
      });
      setSublocations(copy);
    }
  }, [locationValue]);

  const handleLocationChange = (e, index) => {
    const location_values = [...locationValue];
    location_values.splice(index);
    location_values.push(e.target.value);
    setLocationValue(location_values);
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      let payload = { ...dataToSend };
      payload["inventory"] = JSON.stringify(inventories);

      const mandatory = [
        "service_name",
        "service_cost",
        "category_id",
        "description",
      ];
      const ef = getEmptyField(payload, mandatory);
      setEmptyField(ef);
      if (ef.length > 0) {
        toast.error("Mandatory field must be filled");
        return;
      }

      //console.log({ payload });

      let res;
      if (!editMode) {
        res = await service.create(payload, selectedFile, attachments);
      } else {
        res = await service.update(id, payload, selectedFile, attachments);
      }

      setIsLoading(false);
      if (res.ok) {
        toast.success("Successfully Saved");

        if (!editMode) {
          if (afterSubmitCallback) {
            afterSubmitCallback();
          } else {
            backToList();
          }
        }
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

 

  const onSelectFile = async (e) => {
    console.log({ e });
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setSelectedFile(e.target.files[0]);
  };

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    console.log({ selectedFile });
    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);
    //console.log({ objectUrl });
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const handleAddNewCategory = async () => {
    if (!newCategory) return;
    const result = await serviceCategory.create({
      name: newCategory,
    });

    if (result.ok) {
      const body = await result.json();
      const data = body.data;
      setCategories((prev) => [{ ...data }, ...prev]);
      setNewCategory("");
    }
  };

  return (
    <Card>
      <LoadingIndicator open={isLoading} />
      <CardHeader>{editMode && "Edit "}Service Information</CardHeader>

      <CardBody>
        <div className="row">
          <div className="col-9">
            <div>
              <NormalInput
                required={true}
                value={dataToSend["service_name"]}
                label="Service Name"
                onchange={handleOnchange}
                name="service_name"
                emptyField={emptyField}
              />
          

              <div className="form-group mb-3">
                <label
                  className="form-label"
                  htmlFor="exampleFormControlInput1"
                >
                  Service Cost <span className="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      {config?.currency_symbol}
                    </div>
                  </div>
                  <input
                    required={true}
                    className={`form-control ${
                      emptyField.includes("service_cost") ? "is-invalid" : ""
                    }`}
                    type={"number"}
                    value={dataToSend["service_cost"]}
                    label="Service Cost"
                    onChange={handleOnchange}
                    name="service_cost"
                    emptyField={emptyField}
                  />
                </div>
              </div>

              <NormalTextArea
                required={true}
                value={dataToSend["description"]}
                label="Description"
                onchange={handleOnchange}
                name="description"
                emptyField={emptyField}
              />
            </div>

            <NormalSelect
              required={true}
              value={dataToSend["category_id"]}
              label="Category"
              onchange={handleOnchange}
              emptyField={emptyField}
              list={categories}
              name="category_id"
              valueKey={"id"}
              onSubmit={handleAddNewCategory}
              addMoreComponent={
                <NormalInput
                  required={true}
                  value={newCategory}
                  label="Category"
                  onchange={(e) => {
                    setNewCategory(e.target.value);
                  }}
                />
              }
            />
          </div>
          <div className="col-3">
            <Card>
              <CardBody>
                <label htmlFor="files2">
                  {preview ? (
                    <>
                      <img src={preview} className="img-thumbnail" alt="" />
                      <div
                        style={{
                          textAlign: "center",
                          cursor: "pointer",
                          marginTop: "5px",
                        }}
                      >
                        Change Photo <i className="fa fa-camera"></i>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          minHeight: "150px",
                          alignItems: "center",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <i className="fa fa-camera"></i>
                        <div>Add a Photo</div>
                      </div>
                    </>
                  )}
                </label>
                <input
                  id="files2"
                  onChange={onSelectFile}
                  style={{ visibility: "hidden", position: "absolute" }}
                  type="file"
                  accept="image/png, image/jpeg"
                />
              </CardBody>
            </Card>
          </div>
        </div>

        <Card style={{ marginTop: "10px" }}>
          <CardHeader>Attachments</CardHeader>
          <CardBody>
            <MultipleFilesAttachments
              attachments={attachments}
              setAttachments={setAttachments}
            ></MultipleFilesAttachments>
          </CardBody>
        </Card>

        <Card>
          <LoadingIndicator open={isLoading} />
          <CardHeader>More Information</CardHeader>
          <CardBody>
            <NormalSelect
              value={dataToSend["vendor_id"]}
              label="Vendor"
              onchange={handleOnchange}
              list={vendorList}
              valueKey="id"
              name="vendor_id"
            />
            <NormalSelect
              value={dataToSend["customer_id"]}
              label="Customer"
              onchange={handleOnchange}
              list={customerList}
              valueKey="id"
              name="customer_id"
            />
          </CardBody>
        </Card>
    
        <div className="mt-4 flex">
          <PermissionChecker permissions={["create service", "edit service"]} hideIfNotAllowed>
          <button
            className="btn btn-outline-theme btn-lg me-2"
            onClick={handleSubmit}
          >
            {editMode ? "SAVE" : "ADD"}
            </button>
            </PermissionChecker>
          <button
            className="btn btn-outline-danger btn-lg"
            onClick={afterSubmitCallback ? afterSubmitCallback : backToList}
          >
            CANCEL
          </button>
        </div>
      </CardBody>
    </Card>
  );
}

export default AddService;
